(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-nasal-strips"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-arc-nasal]').forEach(root => {
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent || '[]');
    const stage = root.querySelector('[data-arc-stage]');
    const thumbs = [...root.querySelectorAll('[data-img]')];
    const colors = [...root.querySelectorAll('[data-choose-color]')];
    const packs = [...root.querySelectorAll('[data-choose-pack]')];
    const form = root.querySelector('.arc-nasal__form');
    const add = root.querySelector('[data-add]');
    const sticky = root.querySelector('[data-sticky]');
    let color='Pink', pack='30';
    const money = cents => new Intl.NumberFormat('en-PH',{style:'currency',currency:'PHP',maximumFractionDigits:2}).format(cents/100);
    const image = b => { if(!b)return;stage.src=b.dataset.img;stage.alt=b.dataset.alt;thumbs.forEach(x=>x.classList.toggle('is-active',x===b)); };
    function update() {
      colors.forEach(b=>{const yes=b.dataset.chooseColor===color;b.classList.toggle('is-selected',yes);b.setAttribute('aria-pressed',String(yes));});
      packs.forEach(b=>{const yes=b.dataset.choosePack===pack;b.classList.toggle('is-selected',yes);b.setAttribute('aria-pressed',String(yes));});
      root.querySelector('[data-color-label]').textContent=color;
      root.querySelector('[data-pack-caption]').textContent=pack==='30'?'30 strips per pouch':'2 pouches · 60 strips';
      const variant=variants.find(v=>(v.options||[]).some(x=>x.toLowerCase()===color.toLowerCase())&&(v.options||[]).some(x=>x.includes(pack)));
      if(variant){root.querySelector('[data-variant-id]').value=variant.id;root.querySelector('[data-price]').textContent=money(variant.price);add.disabled=!variant.available;add.textContent=variant.available?'Add to cart +':'Sold out';root.querySelector('[data-availability]').textContent=variant.available?'':'This option is currently unavailable.';}
      else{root.querySelector('[data-variant-id]').value='';root.querySelector('[data-price]').textContent='';add.disabled=true;add.textContent='Unavailable';root.querySelector('[data-availability]').textContent='This option is currently unavailable.';}
      root.querySelector('[data-sticky-detail]').textContent=color+' · '+(pack==='30'?'1 Pack':'2 Packs');
      root.querySelector('[data-sticky-image]').src=thumbs.find(b=>b.dataset.color===color).dataset.img;
    }
    thumbs.forEach(b=>b.addEventListener('click',()=>image(b)));
    colors.forEach(b=>b.addEventListener('click',()=>{color=b.dataset.chooseColor;image(thumbs.find(x=>x.dataset.color===color));update()}));
    packs.forEach(b=>b.addEventListener('click',()=>{pack=b.dataset.choosePack;update()}));
    root.querySelectorAll('[data-jump-color]').forEach(b=>b.addEventListener('click',()=>{color=b.dataset.jumpColor;image(thumbs.find(x=>x.dataset.color===color));update();root.querySelector('.arc-nasal__buy').scrollIntoView({behavior:'smooth',block:'start'})}));
    const lightbox=root.querySelector('[data-lightbox]');root.querySelector('[data-arc-zoom]').addEventListener('click',()=>{lightbox.querySelector('img').src=stage.src;lightbox.querySelector('img').alt=stage.alt;lightbox.hidden=false});root.querySelector('[data-close]').addEventListener('click',()=>lightbox.hidden=true);lightbox.addEventListener('click',e=>{if(e.target===lightbox)lightbox.hidden=true});document.addEventListener('keydown',e=>{if(e.key==='Escape')lightbox.hidden=true});
    root.querySelector('[data-sticky-button]').addEventListener('click',()=>root.querySelector('.arc-nasal__buy').scrollIntoView({behavior:'smooth',block:'start'}));
    new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:0}).observe(form);
    const current=variants.find(v=>String(v.id)===String(root.querySelector('[data-variant-id]').value));if(current){const c=(current.options||[]).find(x=>/^(pink|black)$/i.test(x));if(c)color=c;const p=(current.options||[]).find(x=>/30|60/.test(x));if(p)pack=/60/.test(p)?'60':'30';}
    image(thumbs.find(x=>x.dataset.color===color));update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-vibration-alarm"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-arc-pdp]');

    roots.forEach((root) => {
      const track = root.querySelector('[data-arc-track]');
      const slides = [...root.querySelectorAll('[data-arc-slide]')];
      const thumbs = [...root.querySelectorAll('[data-arc-thumb]')];
      const quantityInput = root.querySelector('[data-arc-quantity-input]');
      const total = root.querySelector('[data-arc-total]');
      const stickyTotal = root.querySelector('[data-arc-sticky-total]');
      const form = root.querySelector('.arc-product-form');
      const addButton = root.querySelector('.arc-add');
      const sticky = root.querySelector('[data-arc-sticky]');
      const basePrice = Number(root.querySelector('.arc-price__sale')?.textContent.replace(/[^0-9.]/g, '')) || 0;
      const currencyText = root.querySelector('.arc-price__sale')?.textContent || '';

      const setActiveThumb = (index) => {
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          setActiveThumb(index);
        });
      });

      if (track && slides.length) {
        track.addEventListener('scroll', () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          setActiveThumb(Math.max(0, Math.min(index, slides.length - 1)));
        }, { passive: true });
      }

      root.querySelectorAll('[data-arc-quantity-option]').forEach((button) => {
        button.addEventListener('click', () => {
          const quantity = Number(button.dataset.arcQuantityOption || 1);
          root.querySelectorAll('[data-arc-quantity-option]').forEach((option) => {
            const selected = option === button;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-pressed', String(selected));
          });
          if (quantityInput) quantityInput.value = String(quantity);

          if (basePrice > 0) {
            const decimals = currencyText.includes('.') ? 2 : 0;
            const numeric = (basePrice * quantity).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
            const currencyPrefix = currencyText.replace(/[0-9.,\s]/g, '').trim();
            const formatted = `${currencyPrefix}${numeric}`;
            if (total) total.textContent = formatted;
            if (stickyTotal) stickyTotal.textContent = formatted;
          }
        });
      });

      root.querySelector('[data-arc-sticky-submit]')?.addEventListener('click', () => addButton?.click());

      if (sticky && form) {
        const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
        observer.observe(form);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();
})();
